import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
// We need to extend the tailwind-merge configuration to correctly handle "type-*" classes.
// See https://github.com/dcastil/tailwind-merge/blob/v3.0.1/docs/configuration.md#extending-the-tailwind-merge-config
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            // Match anything starting with "type-". This will de-dupe "type-*" classes, last wins.
            type: [(classPart) => /^type-(.+)$/.test(classPart)],
        },
    },
});
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
